var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFunnels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 37.5H15V35H7.5V5H27.5V17.5H30V5C30 3.625 28.875 2.5 27.5 2.5H7.5C6.125 2.5 5 3.625 5 5V35C5 36.375 6.125 37.5 7.5 37.5ZM33.3867 20.3622L37.1367 24.1122C37.6242 24.5997 37.6242 25.3872 37.1367 25.8747L25.5242 37.4872H20.0117V31.9747L31.6242 20.3622C32.1117 19.8747 32.8992 19.8747 33.3867 20.3622ZM22.4992 34.9997H24.4867L30.7367 28.7497L28.7492 26.7622L22.4992 33.0122V34.9997ZM30.5117 24.9997L32.4992 26.9872L34.4867 24.9997L32.4992 23.0122L30.5117 24.9997ZM21.25 18.75H13.75C11.675 18.75 10 20.425 10 22.5V23.75H12.5V22.5C12.5 21.8125 13.0625 21.25 13.75 21.25H21.25C21.9375 21.25 22.5 21.8125 22.5 22.5V23.75H25V22.5C25 20.425 23.325 18.75 21.25 18.75ZM22.5 12.5C22.5 15.2625 20.2625 17.5 17.5 17.5C14.7375 17.5 12.5 15.2625 12.5 12.5C12.5 9.7375 14.7375 7.5 17.5 7.5C20.2625 7.5 22.5 9.7375 22.5 12.5ZM20 12.5C20 11.125 18.875 10 17.5 10C16.125 10 15 11.125 15 12.5C15 13.875 16.125 15 17.5 15C18.875 15 20 13.875 20 12.5Z",
    fill: "url(#paint0_linear_181_2573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_2573",
    x1: 5,
    y1: 3.10364,
    x2: 38.3334,
    y2: 38.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFunnels);
export default __webpack_public_path__ + "static/media/no-funnels.13e2dd875f5452e7cffa742675ee5640.svg";
export { ForwardRef as ReactComponent };